import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter, NavLink } from 'react-router-dom'

class MobileHeaderContainer extends Component {
    state = {
        isOpen: false
    }

    toggleHeader = () => {
        this.setState(prevState => ({
            isOpen: !prevState.isOpen
        }))
    }

    render() {
        let activeLangClassHr = 'mobile-nav-lang--active'
        let activeLangClassEn = ''
        if (this.props.activeLang === 'en') {
            activeLangClassHr = ''
            activeLangClassEn = 'mobile-nav-lang--active'
        }

        const activeClass = this.state.isOpen ? 'mobile-nav--active' : ''
        const navItems = this.props.langData.map((val, key) => (
            <NavLink
                exact
                to={val.path}
                className="mobile-nav-item"
                activeClassName="mobile-nav-item--active"
                onClick={this.toggleHeader}
                key={key}
            >
                <div className="mobile-nav-item__text">
                    {val.title}
                </div>
            </NavLink>
        ))
        return (
            <div className="mobile-header-container">
                <div className="hamburger" onClick={this.toggleHeader}>
                    <div className="hamburger-inner">
                        <div className="hamburger-inner__item"></div>
                        <div className="hamburger-inner__item"></div>
                        <div className="hamburger-inner__item"></div>
                    </div>
                </div>
                <div className={`mobile-nav ${activeClass}`}>
                    <div className="mobile-nav-lang">
                        <a href="/">
                            <span className={activeLangClassHr}>HR</span>
                        </a>
                        <div className="mobile-nav-lang__dash"></div>
                        <a href="/en">
                            <span className={activeLangClassEn}>EN</span>
                        </a>
                    </div>
                    <div className="mobile-nav-container">
                        {navItems}
                    </div>
                    <div className="mobile-nav-social">
                        <a
                            href="https://web.facebook.com/BedrinaProjekt/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mobile-nav-social-item"
                        >
                            <img
                                className="mobile-nav-social-item__img"
                                src="/images/ico/bed_facebookmobile.png"
                            />
                        </a>
                        <a
                            href=""
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mobile-nav-social-item"
                        >
                            <img
                                className="mobile-nav-social-item__img"
                                src="/images/ico/bed_instagrammobile.png"
                            />
                        </a>
                        <a
                            href="https://linkedin.com/in/goran-bedrina-30a36345"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mobile-nav-social-item"
                        >
                            <img
                                className="mobile-nav-social-item__img"
                                src="/images/ico/bed_linkedinmobile.png"
                            />
                        </a>
                        <div>
                            <img
                                className="mobile-nav-social-logo"
                                src="/images/ico/bed_logomenu.png"
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    langData: state.langData.header,
    activeLang: state.activeLang
})

export default withRouter(connect(mapStateToProps)(MobileHeaderContainer))



// WEBPACK FOOTER //
// ./src/scripts/containers/MobileHeaderContainer.jsx